fragment confirmationTokenDetails on ConfirmationTokenType {
    created
    confirmedAt
    user {
        username
    }
}
